export default function WhatsAppButton() {
    const phoneNumber = "584120332325";
    const message = encodeURIComponent("Hola! Quisiera más información sobre los servicios de Alfa y Omega Trading.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-8 right-8 z-[100] bg-[#25D366] text-white w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform active:scale-95 group"
            aria-label="Contactar por WhatsApp"
        >
            <i className="ri-whatsapp-line text-4xl"></i>

            {/* Tooltip */}
            <span className="absolute right-20 bg-white text-gray-800 px-4 py-2 rounded-lg text-sm font-bold shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border border-gray-100">
                ¿Te ayudamos por WhatsApp?
                <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45 border-r border-t border-gray-100"></span>
            </span>
        </a>
    );
}
